import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import CheckoutPage from "./components/checkoutpage/CheckoutPage";
import InformationCollection from "./components/informationCollection/InformationCollection";
import LoaderPage from "./components/loader/LoaderPage";
import ResponsePage from "./components/responsePage/ResponsePage";

const RedirectRoot = () => {
  useEffect(() => {
    window.location.replace("https://touchpay.pro/");
  }, []);
  return null;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RedirectRoot />} />
        <Route path="/paymentLink" element={<InformationCollection />} />

        <Route path="/quickbilpay/*" element={<CheckoutPage />} />
        <Route path="/loader" element={<LoaderPage />} />
        <Route path="/response-page" element={<ResponsePage />} />

      </Routes>
    </Router>
  );
}

export default App;
